import { Injectable } from '@angular/core';
import { RiwayatJabatan } from '../../../models/pegawai/riwayat-jabatan.model';
import { Adapter } from '../adapter.service';

@Injectable({
  providedIn: 'root',
})
export class RiwayatJabatanAdapter implements Adapter<RiwayatJabatan> {
  adapt(item: any): RiwayatJabatan {
    return {
      id: item.idRiwayatJabatan,
      idKaryawan: item.idKaryawan,
      idJabatan: item.idJabatan,
      idGolonganJabatan: item.idGolonganJabatan,
      jabatan: item.jabatan,
      tmt: item.tmt,
      noSk: item.noSk,
      tanggalSk: item.tanggalSk,
      satuanKerja: item.satuanKerja,
      dateMake: item.dateMake,
      kelasJabatan: item.kelasJabatan,
      url: item.url,
      keterangan: item.keterangan,
      karyawan: item.karyawan,
      golonganJabatan: item.golongan ? item.golongan : item.golonganJabatan,
      statusAktif: item.statusAktif,
      catatan: item.catatan,
    };
  }
}
